import React from 'react';
import { PropTypes } from 'prop-types';
import { Button, Layout } from '../../../../core';
import { i18n } from '../../../../i18n/translate';

export const Header = props => {
  const {
    heading,
    headingLevel,
    showSelectOptions,
    singleSelect,
    dataObjectType,
    dataObjectAttribute,
    selectedCount,
    onSelectAll,
    onClearAll,
  } = props;

  const renderHeadingLevel = (content, level) => {
    if (!content) return null;
    const HeadingTag = `h${level}`;
    return <HeadingTag>{content}</HeadingTag>;
  };

  return (
    <div className="checkbox-list-header">
      {heading ? renderHeadingLevel(heading, headingLevel) : null}
      {!singleSelect && showSelectOptions && (
        <Layout role="toolbar" aria-label="Selection options" variant="flex" justifyContent={'space-between'} p={'sm'}>
          <Layout variant="flex" gap={'30px'}>
            <Button
              variant="link"
              onClick={onSelectAll}
              data-object-type={dataObjectType}
              data-object-attribute={dataObjectAttribute}
              data-object-action={`select-all-${dataObjectType}`}
            >
              {i18n.t('Select All')}
            </Button>
            <span role="status" aria-live="polite" aria-atomic="true" className="selection-count">
              {selectedCount} {i18n.t('Selected')}
            </span>
          </Layout>
          <Button
            variant="link"
            onClick={onClearAll}
            data-object-type={dataObjectType}
            data-object-attribute={dataObjectAttribute}
            data-object-action={`clear-all-${dataObjectType}`}
            aria-label={i18n.t('Clear all selections')}
            disabled={selectedCount === 0}
          >
            {i18n.t('Clear')}
          </Button>
        </Layout>
      )}
    </div>
  );
};

Header.propTypes = {
  heading: PropTypes.string,
  headingLevel: PropTypes.number,
  showSelectOptions: PropTypes.bool,
  singleSelect: PropTypes.bool,
  dataObjectType: PropTypes.string,
  dataObjectAttribute: PropTypes.string,
  selectedCount: PropTypes.number,
  onSelectAll: PropTypes.func,
  onClearAll: PropTypes.func,
};
